<app-page-loader *ngIf="isLoading"></app-page-loader>
<div [ngClass]="{'accent-5-bg warn-solid-fg': ServiceStatus.DOWN === serviceCardInfo.status, 'cursor-pointer': !loader}"
     class="flex flex-col service-card p-24"
     (click)="!loader ? goToBlueprint() : ''">
  <div class="flex flex-row mb-24">
    <img src="/assets/icons/bank.svg" class="icon-40 w-50 h-42 mr-20">
    <div class="mat-headline-5 fw-bold word-break-word description mb-0">
      {{serviceCardInfo?.blueprint?.name ? serviceCardInfo?.blueprint?.name : serviceCardInfo?.name}}
    </div>
  </div>
  <mat-divider class="mb-16"></mat-divider>
  <div *ngIf="!loader; else skeletonLoader" class="flex flex-row mb-16">
    <div *ngIf="serviceCardInfo.status" [ngClass]="statusInfo[serviceCardInfo.status].colorClass" class="traffic-light icon-container mr-16">
      <mat-icon svgIcon="{{statusInfo[serviceCardInfo.status]?.icon}}" class="justify-center items-center white-fg icon icon-sm"></mat-icon>
    </div>
    <div class="mat-subtitle-2 fw-600 word-break-word">
      {{(serviceCardInfo.status ? 'SERVICE_STATUS.' + serviceCardInfo.status : 'INSTANCE_STATUS.NA') | transloco}}
    </div>
  </div>
  <div class="flex flex-col flex-auto">
    <div *ngIf="!loader; else skeletonLoader">
      <div *ngIf="ServiceStatus.IN_PROGRESS === serviceCardInfo.status" class="flex flex-row justify-between w-100-percent mb-8">
        <span class="mat-body-1 m-0 fs-14 fw-500 word-break-word">
          {{trialStatus}}
        </span>
      </div>
      <div *ngIf="ServiceStatus.LIVE === serviceCardInfo.status" class="flex flex-row justify-between w-100-percent mb-16">
        <span class="mat-body-1 m-0 fs-14 fw-500 word-break-word">
          {{trialStatus}}
        </span>
      </div>
    </div>
    <div *ngIf="ServiceStatus.IN_PROGRESS === serviceCardInfo.status" class="flex flex-row justify-between mb-16">
      <span class="mat-body-1 m-0 fs-14 fw-500 word-break-word">
        <!-- {{'SERVICE_CARD.SETUP_PROGRESS.' + serviceCardInfo.currentStep | transloco}} -->
      </span>
    </div>
    <div *ngIf="region" class="flex flex-row mb-8">
      <mat-icon svgIcon="place" class="icon-sm mr-12"></mat-icon>
      <span class="mat-small fw-700 m-0 mt-0">{{
        region | uppercase}}</span><br>
    </div>

    <div *ngIf="tenantDetails?.region" class="flex flex-row mb-8">
      <mat-icon svgIcon="place" class="icon-sm mr-12"></mat-icon>
      <span class="mat-small fw-700 m-0 mt-0">
        {{tenantDetails?.region | uppercase}}
        <!-- {{tenantDetails?.temenosRegion | uppercase}} -->
      </span><br>
    </div>

    <div class="flex flex-row">
      <mat-icon svgIcon="token" class="icon-sm mr-12"></mat-icon>
      <span class="mat-small fw-700 m-0 mt-0 mr-10">{{('BLUEPRINT_SUMMARY.RELEASE' | transloco) + ' ' +
        (latestReleaseVersion ? latestReleaseVersion : isSandboxCard ? (serviceCardInfo?.serviceVersionsInfo?.devVersion?.releaseVersion ?
        serviceCardInfo?.serviceVersionsInfo?.devVersion?.releaseVersion: 'N/A') :
        (serviceCardInfo?.serviceVersionsInfo?.currentVersion?.releaseVersion ?
        serviceCardInfo?.serviceVersionsInfo?.currentVersion?.releaseVersion : 'N/A')) }}
      </span>
       <div *ngIf="isAMR" class="flex flex-row justify-center items-center amr-text pl-10">
        {{('BLUEPRINT_SUMMARY.AMR' | transloco)}}
      </div><br>
      </div>

      <div *ngIf="serviceCardInfo.status === 'LIVE' && serviceCardInfo?.serviceDefinitionVersion" class="flex flex-row mt-8">
        <mat-icon svgIcon="pages" class="icon-sm mr-12"></mat-icon>
        <span class="mat-small fw-700 m-0 mt-0">
          {{'INSTANCE_STATUS.VERSION' | transloco}}
          <span class="pl-4">{{serviceCardInfo?.serviceDefinitionVersion}}</span>
        </span><br>
      </div>
  </div>

  <div *ngIf="ServiceStatus.DOWN === serviceCardInfo.status" class="flex flex-col justify-between flex-auto">
    <div>Short description of a problem.</div>
    <button class="justify-center items-center btn-link view-ticket-button">
      <mat-icon svgIcon="open_in_new" class="justify-center items-center icon-sm mr-6"></mat-icon>
      <span>{{'SERVICE_CARD.VIEW_TICKET' | transloco}}</span>
    </button>
  </div>
  <ng-template #skeletonLoader>
    <div class="pl-6 skeleton-loader">
      <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
    </div>
  </ng-template>
</div>
